<template>
    <div class="homePage">
        <headerNotice routerName="系统首页"></headerNotice>
        <!-- 帐额统计 -->
        <div class="cardBox">
            <el-row class="row" :gutter="18">
                <el-col :span="4">
                    <div class="box-card">
                        <i class="one"></i>
                        <div class="txt">
                            <p>今日订单总数</p>
                            <span>{{items.orderNum_Today}}</span>
                        </div>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="box-card">
                        <i class="two"></i>
                        <div class="txt">
                            <p>今日销售总额</p>
                            <span>￥{{items.salesAmount_Today||0}}</span>
                        </div>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="box-card">
                        <i class="three"></i>
                        <div class="txt">
                            <p>昨日销售总额</p>
                            <span>￥{{items.salesAmount_Yesterday||0}}</span>
                        </div>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="box-card">
                        <i class="four"></i>
                        <div class="txt">
                            <p>近7天销售总额</p>
                            <span>￥{{items.salesAmount_Sevendays||0}}</span>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!-- 待处理事务 -->
        <div class="waitHandle">
            <h1>待处理事务</h1>
            <div class="handleList">
                <router-link :to="{'path':'/orderList?status=3'}" class="linkTag">
                    <p>待审核订单</p>
                    <span>
                        （
                        <i>{{items.waitAudit||0}}</i>）
                    </span>
                </router-link>
                <router-link :to="{'path':'/orderList?status=8'}" class="linkTag">
                    <p>已发货订单</p>
                    <span>
                        （
                        <i>{{items.delivered||0}}</i>）
                    </span>
                </router-link>
                <router-link :to="{'path':'/orderList?status=5'}" class="linkTag">
                    <p>异常订单</p>
                    <span>
                        （
                        <i>{{items.auditFail||0}}</i>）
                    </span>
                </router-link>
                <router-link :to="{'path':'/orderList?status=4'}" class="linkTag">
                    <p>待发货订单</p>
                    <span>
                        （
                        <i>{{items.waitDeliver||0}}</i>）
                    </span>
                </router-link>
                <router-link :to="{'path':'/orderList?status=10'}" class="linkTag">
                    <p>已完成订单</p>
                    <span>
                        （
                        <i>{{items.finished||0}}</i>）
                    </span>
                </router-link>
                <!-- <router-link :to="{'path':'/serviceList'}" class="linkTag">
                    <p>待维修确认订单</p>
                    <span>
                        （
                        <i>{{items.waitService||0}}</i>）
                    </span>
                </router-link> -->
            </div>
        </div>
        <!-- 运营快捷入口 -->
        <div class="operation">
            <h1>运营快捷入口</h1>
            <div class="enterList">
                <router-link :to="{'path':'/addGoods'}" class="linkTag">
                    <i></i>
                    <span>添加商品</span>
                </router-link>
                <router-link :to="{'path':'/orderList'}" class="linkTag">
                    <i></i>
                    <span>订单列表</span>
                </router-link>
                <router-link :to="{'path':'/customer'}" class="linkTag">
                    <i></i>
                    <span>用户管理</span>
                </router-link>
                <router-link :to="{'path':'/orderCounts'}" class="linkTag">
                    <i></i>
                    <span>交易统计</span>
                </router-link>
                <!-- <router-link :to="{'path':'/fullReduction'}" class="linkTag">
                    <i></i>
                    <span>促销管理</span>
                </router-link> -->
                <router-link :to="{'path':'/advertisingList'}" class="linkTag">
                    <i></i>
                    <span>运营管理</span>
                </router-link>
                <!-- <router-link :to="{'path':'/giftList'}" class="linkTag">
                    <i></i>
                    <span>积分兑换</span>
                </router-link> -->
                <!-- <router-link :to="{'path':'/salesman'}" class="linkTag">
                    <i></i>
                    <span>业务员管理</span>
                </router-link> -->
                <router-link :to="{'path':'/baseOption'}" class="linkTag">
                    <i></i>
                    <span>系统设置</span>
                </router-link>
            </div>
        </div>
        <!-- 商品、用户总览 -->
        <div class="overview">
            <div class="goods">
                <h3>商品总览</h3>
                <ul>
                    <li>
                        <span>{{items.item_Unshelves||0}}</span>
                        <p>已下架</p>
                    </li>
                    <li>
                        <span>{{items.item_Shelvesed||0}}</span>
                        <p>已上架</p>
                    </li>
                    <!-- <li>
                        <span>{{items.item_StockTight||0}}</span>
                        <p>库存紧张</p>
                    </li> -->
                    <li>
                        <span>{{items.item_All||0}}</span>
                        <p>全部商品</p>
                    </li>
                </ul>
            </div>
            <div class="user">
                <h3>客户总览</h3>
                <ul>
                    <li>
                        <span>{{items.newUser_Today||0}}</span>
                        <p>今日新增</p>
                    </li>
                    <li>
                        <span>{{items.newUser_Yesterday||0}}</span>
                        <p>昨日新增</p>
                    </li>
                    <li>
                        <span>{{items.newUser_Month||0}}</span>
                        <p>本月新增</p>
                    </li>
                    <li>
                        <span>{{items.userCount||0}}</span>
                        <p>客户总数</p>
                    </li>
                </ul>
            </div>
            <!-- <div class="gift">
                <h3>礼品总览</h3>
                <ul>
                    <li>
                        <span>{{items.gift_Unshelves||0}}</span>
                        <p>已下架</p>
                    </li>
                    <li>
                        <span>{{items.gift_Shelvesed||0}}</span>
                        <p>已上架</p>
                    </li>
                    <li>
                        <span>{{items.gift_StockTight||0}}</span>
                        <p>库存紧张</p>
                    </li>
                    <li>
                        <span>{{items.gift_All||0}}</span>
                        <p>全部礼品</p>
                    </li>
                </ul>
            </div> -->
            <!-- <div class="salesman">
                <h3>业务员总览</h3>
                <ul>
                    <li>
                        <span>{{items.newSalesman_Today||0}}</span>
                        <p>今日新增</p>
                    </li>
                    <li>
                        <span>{{items.newSalesman_Yesterday||0}}</span>
                        <p>昨日新增</p>
                    </li>
                    <li>
                        <span>{{items.newSalesman_Month||0}}</span>
                        <p>本月新增</p>
                    </li>
                    <li>
                        <span>{{items.salesmanCount||0}}</span>
                        <p>业务员总数</p>
                    </li>
                </ul>
            </div> -->
        </div>
        <!-- 订单统计 -->
        <div class="orderCount">
            <h1>订单统计</h1>
            <div class="orderChartBox">
                <div class="left">
                    <div class="currentCount">
                        <p>本月订单总数</p>
                        <div>{{orderCountData.orderCountGrowth.thisMonthOrderCount}}</div>
                        <p v-if="orderCountData.orderCountGrowth.monthCountGrowth>=0">
                            <span class="add">
                                <i></i>
                                {{orderCountData.orderCountGrowth.monthCountGrowth*100}}%
                            </span>
                            同比上月
                        </p>
                        <p v-else>
                            <span class="reduce">
                                <i></i>
                                {{orderCountData.orderCountGrowth.monthCountGrowth*100}}%
                            </span>
                            同比上月
                        </p>
                    </div>
                    <div class="currentWeek">
                        <p>本周订单总数</p>
                        <div>{{orderCountData.orderCountGrowth.thisWeekOrderCount}}</div>
                        <p v-if="orderCountData.orderCountGrowth.weekCountGrowth>=0">
                            <span class="add">
                                <i></i>
                                {{orderCountData.orderCountGrowth.weekCountGrowth*100}}%
                            </span>
                            同比上周
                        </p>
                        <p v-else>
                            <span class="reduce">
                                <i></i>
                                {{orderCountData.orderCountGrowth.weekCountGrowth*100}}%
                            </span>
                            同比上周
                        </p>
                    </div>
                </div>
                <div class="right">
                    <div class="top">
                        <h4>订单统计</h4>
                        <div class="time">
                            <el-date-picker
                                v-model="orderTime"
                                @change="orderCountChange"
                                type="daterange"
                                align="right"
                                value-format="yyyy-MM-dd"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions"
                            ></el-date-picker>
                        </div>
                    </div>
                    <div class="bottom" v-loading="loading">
                        <div id="orderChart" :style="{width: '100%', height: '400px'}"></div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 销售统计 -->
        <div class="saleCount">
            <h1>销售统计</h1>
            <div class="orderChartBox">
                <div class="left">
                    <div class="currentCount">
                        <p>本月销售总额</p>
                        <div>{{saleCountData.orderAmountGrowth.thisMonthOrderAmount}}</div>
                        <p v-if="saleCountData.orderAmountGrowth.monthAmountGrowth>=0">
                            <span class="add">
                                <i></i>
                                {{saleCountData.orderAmountGrowth.monthAmountGrowth*100}}%
                            </span>
                            同比上月
                        </p>
                        <p v-else>
                            <span class="reduce">
                                <i></i>
                                {{saleCountData.orderAmountGrowth.monthAmountGrowth*100}}%
                            </span>
                            同比上月
                        </p>
                    </div>
                    <div class="currentWeek">
                        <p>本周销售总额</p>
                        <div>{{saleCountData.orderAmountGrowth.thisWeekOrderAmount}}</div>
                        <p v-if="saleCountData.orderAmountGrowth.weekAmountGrowth>=0">
                            <span class="add">
                                <i></i>
                                {{saleCountData.orderAmountGrowth.weekAmountGrowth*100}}%
                            </span>
                            同比上周
                        </p>
                        <p v-else>
                            <span class="reduce">
                                <i></i>
                                {{saleCountData.orderAmountGrowth.weekAmountGrowth*100}}%
                            </span>
                            同比上周
                        </p>
                    </div>
                </div>
                <div class="right">
                    <div class="top">
                        <h4>销售额统计</h4>
                        <div class="time">
                            <el-date-picker
                                v-model="saleTime"
                                @change="saleCountChange"
                                type="daterange"
                                align="right"
                                value-format="yyyy-MM-dd"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions"
                            ></el-date-picker>
                        </div>
                    </div>
                    <div class="bottom" v-loading="loading">
                        <div id="saleChart" :style="{width: '100%', height: '400px'}"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import headerNotice from "./../../components/common/headerNotice.vue";
import echarts from "echarts";
export default {
  data() {
    return {
      loading: false,
      items: {},
      orderCountData: {
        date: [],
        count: [],
        orderCountGrowth: {
          monthCountGrowth: 0,
          thisMonthOrderCount: 0,
          thisWeekOrderCount: 0,
          weekCountGrowth: 0
        }
      },
      saleCountData: {
        date: [],
        amount: [],
        orderAmountGrowth: {
          monthAmountGrowth: 0,
          thisMonthOrderAmount: 0,
          thisWeekOrderAmount: 0,
          weekAmountGrowth: 0
        }
      },
      orderTime: [],
      saleTime: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "本日",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              // start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  components: {
    headerNotice
  },
  mounted() {
    //获取数据
    this.getDatas();
    this.setWeekTime();
  },
  methods: {
    //获取数据
    getDatas() {
      let self = this;
      self.loading = true;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminStatistics/GetIndexStatistics",
        success(res) {
          self.items = res;
          self.loading = false;
        },
        fail(res) {
          self.loading = false;
        }
      });
    },
    //设置默认近7天数据
    setWeekTime() {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
      this.orderTime = [start, end];
      this.getOrderEchartData(this.orderTime);
      this.saleTime = [start, end];
      this.getSaleEchartData(this.saleTime);
    },
    //构建订单echart图
    setOrderChart() {
      let self = this;
      var myChart = echarts.init(document.getElementById("orderChart"));
      // 绘制图表
      myChart.setOption({
        xAxis: {
          name: "日期",
          type: "category",
          boundaryGap: false,
          data: self.orderCountData.date
        },
        yAxis: {
          name: "订单数（个）",
          type: "value"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        series: [
          {
            data: self.orderCountData.count,
            type: "line",
            hoverAnimation: true,
            smooth: true,
            areaStyle: {},
            itemStyle: {
              borderColor: "#000",
              color: "#DBEEFC"
            },
            lineStyle: {
              color: "#49A9EE"
            }
          }
        ]
      });
    },
    //构建销售额echart图
    setSaleChart() {
      let self = this;
      var myChart = echarts.init(document.getElementById("saleChart"));
      // 绘制图表
      myChart.setOption({
        xAxis: {
          name: "日期",
          type: "category",
          boundaryGap: false,
          data: self.saleCountData.date
        },
        yAxis: {
          name: "销售额（元）",
          type: "value"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        series: [
          {
            data: self.saleCountData.amount,
            type: "line",
            hoverAnimation: true,
            smooth: true,
            areaStyle: {},
            itemStyle: {
              borderColor: "#000",
              color: "#DBEEFC"
            },
            lineStyle: {
              color: "#49A9EE"
            }
          }
        ]
      });
    },
    //订单统计数据
    getOrderEchartData(time, echartId) {
      let self = this;
      $http.POST({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminStatistics/IndexOrderCountStatistics",
        data: {
          startTime: time[0],
          endTime: time[1]
        },
        success(res) {
          self.orderCountData = res;
          self.setOrderChart();
          self.loading = false;
        },
        fail(res) {
          self.loading = false;
        }
      });
    },
    //销售额统计数据
    getSaleEchartData(time, echartId) {
      let self = this;
      $http.POST({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminStatistics/IndexOrderAmountStatistics",
        data: {
          startTime: time[0],
          endTime: time[1]
        },
        success(res) {
          self.saleCountData = res;
          self.setSaleChart();
          self.loading = false;
        },
        fail(res) {
          self.loading = false;
        }
      });
    },
    //订单日期改变
    orderCountChange() {
      this.getOrderEchartData(this.orderTime);
    },
    //销售额日期改变
    saleCountChange() {
      this.getSaleEchartData(this.saleTime);
    }
  }
};
</script>

<style lang='scss' scoped>
.homePage {
  overflow-x: hidden;
}
// 帐额统计
.cardBox {
  margin: 0 auto;
  margin-top: 40px;
  padding-bottom: 20px;
  .row {
    display: flex;
    justify-content: space-around;
    .box-card {
      padding: 20px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      display: flex;
      align-items: center;
      background: #fff;
      i {
        width: 50px;
        height: 50px;
        display: block;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 100% 100%;
        &.one {
          background-image: url("./../../assets/imgs/u227.png");
        }
        &.two {
          background-image: url("./../../assets/imgs/u250.png");
        }
        &.three {
          background-image: url("./../../assets/imgs/u303.png");
        }
        &.four {
          background-image: url("./../../assets/imgs/day7.png");
        }
      }
      .txt {
        flex: 1;
        margin-left: 20px;
        p {
          color: #666;
          margin-bottom: 5px;
        }
      }
    }
  }
}
// 待处理事务
.waitHandle {
  margin: 20px 200px;
  border: 1px solid #999;
  h1 {
    background: #f3f3f3;
    padding: 10px 20px;
    border-bottom: 0.5px solid #999;
  }
  .handleList {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    padding: 10px 50px;
    background: #fff;
    .linkTag {
      width: 33%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 10px 20px;
      color: #666;
      span {
        display: flex;
        align-items: center;
        color: #666;
        i {
          font-style: normal;
          color: #f63b3b;
        }
      }
      &:hover {
        color: #1abc9c;
      }
    }
  }
}
// 运营快捷入口
.operation {
  margin: 20px 200px;
  margin-top: 40px;
  border: 1px solid #999;
  h1 {
    background: #f3f3f3;
    padding: 10px 20px;
    border-bottom: 0.5px solid #999;
  }
  .enterList {
    display: flex;
    align-items: center;
    background: #fff;
    .linkTag {
      height: 150px;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      padding: 30px 0;
      color: #666;
      border-right: 1px solid #fff;
      border-left: 1px solid #fff;
      box-sizing: border-box;
      &:hover {
        background: #f9f9f9;
        border-right: 1px solid #999;
        border-left: 1px solid #999;
        color: #1abc9c;
      }
      i {
        display: block;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 100% 100%;
        margin-bottom: 20px;
      }
      &:nth-of-type(1) {
        border-left: none;
      }
      &:nth-last-child(1) {
        border-right: none;
      }
      &:nth-of-type(1) i {
        width: 42px;
        height: 42px;
        background-image: url("./../../assets/imgs/addGoods.png");
      }
      &:nth-of-type(2) i {
        width: 40px;
        height: 42px;
        background-image: url("./../../assets/imgs/goodsList.png");
      }
      &:nth-of-type(3) i {
        width: 52px;
        height: 52px;
        background-image: url("./../../assets/imgs/userManager.png");
      }
      &:nth-of-type(4) i {
        width: 50px;
        height: 45px;
        background-image: url("./../../assets/imgs/tranCount.png");
      }
      &:nth-of-type(5) i {
        width: 44px;
        height: 45px;
        background-image: url("./../../assets/imgs/secondSkill.png");
      }

      &:nth-of-type(6) i {
        width: 42px;
        height: 42px;
        background-image: url("./../../assets/imgs/adManager.png");
      }
      &:nth-of-type(7) i {
        width: 43px;
        height: 43px;
        background-image: url("./../../assets/imgs/theme.png");
      }
      &:nth-of-type(8) i {
        width: 32px;
        height: 45px;
        background-image: url("./../../assets/imgs/sms.png");
      }
      &:nth-of-type(9) i {
        width: 45px;
        height: 45px;
        background-image: url("./../../assets/imgs/new.png");
      }
    }
  }
}
//商品、用户总览
.overview {
  margin-top: 40px;
  padding: 0 200px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  div {
    width: 45%;
    border: 1px solid #999;
    box-sizing: border-box;
    background: #fff;
    margin-bottom: 20px;
    h3 {
      background: #f3f3f3;
      padding: 10px 20px;
      border-bottom: 0.5px solid #999;
    }
    ul {
      height: 150px;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      li {
        flex: 1;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        span {
          font-weight: 600;
          color: #f63b3b;
          font-size: 24px;
        }
        p {
          margin-top: 20px;
          font-size: 14px;
          color: #666;
        }
      }
    }
  }
}
//订单统计 销售统计
.orderCount,
.saleCount {
  margin: 0 200px;
  margin-top: 20px;
  border: 1px solid #c5c5c5;
  h1 {
    background: #f3f3f3;
    padding: 10px 20px;
    border-bottom: 0.5px solid #999;
  }
  .orderChartBox {
    width: 100%;
    display: flex;
    justify-content: space-between;
    .left {
      width: 20%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .currentCount,
      .currentWeek {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 20px 0;
        p {
          font-size: 14px;
          color: #999;
          display: flex;
          align-items: center;
          span {
            display: flex;
            align-items: center;
            margin-right: 5px;
            i {
              width: 10px;
              height: 6px;
              background-repeat: no-repeat;
              background-position: center center;
              background-size: 100% 100%;
            }
            &.add {
              color: #27b66b;
              i {
                background-image: url("./../../assets/imgs/add.png");
              }
            }
            &.reduce {
              color: #f04844;
              i {
                background-image: url("./../../assets/imgs/reduce.png");
              }
            }
          }
        }
        div {
          font-size: 24px;
          margin: 10px;
        }
      }
    }
    .right {
      flex: 1;
      height: 100%;
      border-left: 1px solid #c5c5c5;
      .top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 80px;
        padding: 0 30px;
        h4 {
          color: #999;
          font-size: 14px;
          font-weight: normal;
        }
        .time {
          display: flex;
          align-items: center;
          span {
            color: #666;
            margin-right: 20px;
            font-size: 14px;
            cursor: pointer;
            &.current {
              color: #27b66b;
            }
          }
        }
      }
    }
  }
}
</style>
